var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEurekaIconBlue = function SvgEurekaIconBlue(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 841.9",
    style: {
      enableBackground: "new 0 0 841.9 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4965_00000067193819855540282130000008118551454785013685_",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4967_00000017507240664227458650000010232714418713985974_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4969_00000178173539660421388940000016788833238999439506_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4975_00000150071867518243790980000017076873904416627893_",
    transform: "translate(310,20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4977_00000164473871199616082560000009418043219707233974_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M69.1-130.4h-229.5c-79.9,0-145,65-145,145v328.6c0,79.9,65,145,145,145h328.6c79.9,0,145-65,145-145V111.8 c0-13.3-10.8-24.2-24.2-24.2s-24.2,10.8-24.2,24.2v231.3c0,53.3-43.4,96.6-96.6,96.6h-328.6c-53.3,0-96.6-43.4-96.6-96.6V14.5 c0-53.3,43.4-96.6,96.6-96.6H69.1c13.3,0,24.2-10.8,24.2-24.2S82.5-130.4,69.1-130.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4979_00000159431548020252498600000018370977941325280665_",
    transform: "translate(209,386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4981_00000155868338220205928040000016528539503751421318_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M269.2-54.3H48.1C34.8-54.3,24-43.5,24-30.1S34.8-6,48.1-6h221.1c13.3,0,24.2-10.8,24.2-24.2S282.5-54.3,269.2-54.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4983_00000029018455304412384670000005210145865020330431_",
    transform: "translate(120,306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4985_00000077307684605128583540000010533214757978061480_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M358.2-70.9H29.6c-13.3,0-24.2,10.8-24.2,24.2s10.8,24.2,24.2,24.2h328.6c13.3,0,24.2-10.8,24.2-24.2 S371.5-70.9,358.2-70.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4987_00000120549660686767208780000015012422093627801783_",
    transform: "translate(120,226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4989_00000038371711549045332330000014403714739101452972_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M116.6-87.6h-87c-13.3,0-24.2,10.8-24.2,24.2s10.8,24.2,24.2,24.2h87c13.3,0,24.2-10.8,24.2-24.2 S129.9-87.6,116.6-87.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4991_00000134970707992328051450000007428857249220547468_",
    transform: "translate(100,388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4993_00000108300621190154375550000010569530251860131509_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.4-29.7c0-16.7,13.5-30.2,30.2-30.2s30.2,13.5,30.2,30.2C85.8-13,72.3,0.5,55.6,0.5S25.4-13,25.4-29.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4995_00000110455154930620287820000008076234076036447887_",
    transform: "translate(476.4766,35.5234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4997_00000172436067979376119130000008256717811139605925_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.5-145.9c-22.6,0-45.2,8.6-62.4,25.8l-84.7,84.7c-24.5,24.5-41,55.4-47.8,89.3l-13.7,68.5 c-1.6,7.9,0.9,16.1,6.6,21.8c5.7,5.7,13.9,8.2,21.8,6.6l68.5-13.7c33.9-6.8,64.8-23.3,89.3-47.8l84.7-84.7 c34.4-34.4,34.4-90.3,0-124.7C103.7-137.3,81.1-145.9,58.5-145.9z M-95.5,96.3l6.6-32.9c4.9-24.6,16.9-46.9,34.6-64.6 l84.7-84.7c15.5-15.5,40.8-15.5,56.4,0c15.5,15.5,15.5,40.8,0,56.4L2,55.1c-17.7,17.7-40.1,29.7-64.6,34.6L-95.5,96.3z"
  })))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEurekaIconBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eureka-icon-blue.1ee08203.svg";
export { ForwardRef as ReactComponent };